// extracted by mini-css-extract-plugin
export default {"startingInTheFutureInfo":"JoEtE","startingInTheFutureInfoDate":"WgTP1","projectIsInactive":"WtLTp","projectStatus":"u9Zb4","projectWarningStatus":"YwuRX"};